import { useSendCommandAsync } from '@/_core/cqrs/use';
import { RealTimeAction } from '@/_core/fluxstore/types';
import { createUpdatePersonaDescriptionCommand } from '../../../api/commands/factory/createPersonaCommands';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class UpdatePersonaDescription extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'UpdatePersonaDescription';

    public constructor(public id: string, public description: string) {
        super(UpdatePersonaDescription.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: UpdatePersonaDescription): Promise<boolean> => {
    return await useSendCommandAsync(action, {
        createCommand: async () => await createUpdatePersonaDescriptionCommand(action),
    });
};

const reducer = (state: StorymapState, action: UpdatePersonaDescription): void => {
    const persona = state.personas.find((x) => x.id === action.id);

    persona.description = action.description;
};

//@ts-ignore
registerMiddleware(UpdatePersonaDescription.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(UpdatePersonaDescription.ACTION_TYPE, reducer);
